import React from "react";
import '../assets/css/loadingspinner.css'

function Loadingspinner () {
    return (
        <div className="spinner-container">
            <div className="loading-spinner">
            </div>
        </div>
    )
}

export default Loadingspinner;